import { createContext, use } from "react";

export interface ArchiveSearchDialogControls {
  open: (initialQuery?: string) => void;
}

export const ArchiveSearchDialogContext =
  createContext<ArchiveSearchDialogControls | null>(null);

/** Opens the archive quick-search palette, optionally prefilled with a query. */
export function useArchiveSearchDialog(): ArchiveSearchDialogControls {
  const context = use(ArchiveSearchDialogContext);
  if (!context) {
    throw new Error(
      "useArchiveSearchDialog must be used within an ArchiveSearchDialogProvider",
    );
  }
  return context;
}

/** The key combination that opens the palette, in the user's platform notation. */
export const ARCHIVE_SEARCH_SHORTCUT_LABEL = /Mac|iPhone|iPad/.test(navigator.userAgent)
  ? "⌘K"
  : "Strg+K";
